<script setup>
import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';
import { isWahaInbox } from 'dashboard/api/wahaManager';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => ({}),
  },
  showChannelBrand: {
    type: Boolean,
    default: false,
  },
});

const isAmazon = computed(() =>
  props.showChannelBrand &&
  props.inbox.channel_type === 'Channel::Email' &&
  Array.isArray(props.inbox.borderchat_labels) &&
  props.inbox.borderchat_labels.some(label => label?.trim() === '亚马逊邮箱')
);

const isWhatsapp = computed(() =>
  props.showChannelBrand && (
    isWahaInbox(props.inbox) ||
    props.inbox.channel_type === 'Channel::Whatsapp' ||
    (props.inbox.channel_type === 'Channel::TwilioSms' && props.inbox.medium === 'whatsapp')
  )
);
</script>

<template>
  <div :title="inbox.name" class="flex items-center gap-0.5 min-w-0">
    <img
      v-if="isAmazon"
      :src="'/borderchat/amazon-icon-20260828.png'"
      alt="Amazon"
      class="size-4 flex-shrink-0 rounded-sm object-contain"
    />
    <span
      v-else-if="isWhatsapp"
      role="img"
      aria-label="WhatsApp"
      class="i-ri-whatsapp-line size-4 flex-shrink-0 text-[#2bbd35]"
    />
    <ChannelIcon v-else :inbox="inbox" class="size-4 flex-shrink-0 text-n-slate-11" />
    <span class="truncate text-label-small text-n-slate-11">
      {{ inbox.name }}
    </span>
  </div>
</template>
